// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import LeadPreview from './data'

export default function LeadPreviewFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/LeadPreview">
      <LeadPreview {...props}>
        {children}
      </LeadPreview>
    </Flow>
  )
}
